import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component that checks JWT token validity
 * 
 * @param {string} requiredRole - 'engineer', 'client', or 'any'
 * @param {React.Component} children - The component to render if authorized
 */
function ProtectedRoute({ requiredRole, children }) {
  const token = localStorage.getItem('token');
  const userInfoString = localStorage.getItem('user_info');

  // If no token, redirect to login
  if (!token || !userInfoString) {
    return <Navigate to="/login" replace />;
  }

  try {
    // Parse user info
    const userInfo = JSON.parse(userInfoString);
    
    // Decode JWT to check expiration (without verification - just parsing)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const payload = JSON.parse(jsonPayload);
    
    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);
    if (payload.exp < currentTime) {
      // Token expired - clear storage and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user_info');
      return <Navigate to="/login" replace />;
    }

    // Check role authorization
    if (requiredRole === 'any') {
      return children;
    }

    if (requiredRole !== userInfo.role) {
      // Wrong role - redirect to appropriate dashboard
      const redirectPath = userInfo.role === 'engineer' ? '/engineer-dashboard' : '/client-dashboard';
      return <Navigate to={redirectPath} replace />;
    }

    // All checks passed
    return children;

  } catch (error) {
    // Invalid token format - clear and redirect
    console.error('Invalid token:', error);
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    return <Navigate to="/login" replace />;
  }
}

export default ProtectedRoute;